import * as angular from "angular";

function handleCall($mdToast, $translate) {
  return function (msg) {
    if (!msg) {
      return;
    }
    return $mdToast.show(
      $mdToast.simple().position('top right')
        .textContent($translate.instant(msg)));
  }
}

angular
  .module('bringoz.admin.commons')
  .service('handleCall', handleCall);
